// AkıllıÇözüm modu: akillicozum.com.tr veya eski hesap.* alt alan adı
export function isHesapSubdomain() {
  const hostname = window.location.hostname;
  return hostname.startsWith('hesap.') || /(^|\.)akillicozum\.com\.tr$/i.test(hostname);
}

// Eski adres: hesap.weddingtakip.com → www.akillicozum.com.tr'ye taşındı
export function isLegacyHesapDomain() {
  return window.location.hostname === 'hesap.weddingtakip.com';
}

export const AKILLICOZUM_URL = 'https://www.akillicozum.com.tr';

// AkıllıÇözüm için path prefix - subdomain'de '' (boş), normal domain'de '/hesap'
export function hesapPrefix() {
  return isHesapSubdomain() ? '' : '/hesap';
}
